import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../utils/APIS";
import { IDS } from "../utils/IDS";
import { GET } from "../utils/Methods";

export const GetAllpbanner = createAsyncThunk(
  "masters/pbanner/get-all",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.pbanner}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const GetAllwhatcounselling = createAsyncThunk(
  "masters/count/get-all",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.what_counselling}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const GetAllhowcounselling = createAsyncThunk(
  "masters/whoweare/get-all",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.how_counselling}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const GetAllwhopt = createAsyncThunk(
  "masters/whychoose/get-all",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.who_should_opt}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);


export const Slice = createSlice({
  name: "parentalcounselling",
  initialState: {
  pbanner: [],
  what_counselling:[],
  how_counselling:[],
  who_should_opt:[],
  
    
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(GetAllpbanner.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllpbanner.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.pbanner = action.payload?.data || [];
      })
      .addCase(GetAllpbanner.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
       })
     
//what_counselling
       .addCase(GetAllwhatcounselling.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllwhatcounselling.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.what_counselling = action.payload?.data || [];
      })
      .addCase(GetAllwhatcounselling.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
       })

      
        .addCase(GetAllhowcounselling.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllhowcounselling.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.how_counselling = action.payload?.data || [];
      })
      .addCase(GetAllhowcounselling.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
       })

    .addCase(GetAllwhopt.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllwhopt.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.who_should_opt = action.payload?.data || [];
      })
      .addCase(GetAllwhopt.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
       })

      
  },
});

export default Slice.reducer;
